import { ExpenseEntity, ExpenseFilter } from '../../models'

export const SET_EXPENSES = 'SET_EXPENSES'
export const SET_EXPENSES_LOADED = 'SET_EXPENSES_LOADED'
export const SET_EXPENSE_FILTER = 'SET_EXPENSE_FILTER'
export const SET_TOTAL_EXPENSES = 'SET_TOTAL_EXPENSES'

export interface ExpenseState {
  expenses: ExpenseEntity[]
  totalExpenses: number
  isExpensesLoaded: boolean
  expenseFilter: ExpenseFilter
}

interface SetExpensesAction {
  type: typeof SET_EXPENSES
  payload: ExpenseEntity[]
}

interface SetTotalExpensesAction {
  type: typeof SET_TOTAL_EXPENSES
  payload: number
}

interface SetExpensesLoadedAction {
  type: typeof SET_EXPENSES_LOADED
  payload: boolean
}

interface SetExpenseFilterAction {
  type: typeof SET_EXPENSE_FILTER
  payload: ExpenseFilter
}

export type ExpenseAction =
  | SetExpensesAction
  | SetTotalExpensesAction
  | SetExpensesLoadedAction
  | SetExpenseFilterAction
